import { trace } from 'rytm-helpers'

export const initFormValidation = () => {
  const forms = document.querySelectorAll('form')
  if (forms.length) {
    forms.forEach(form => {
      form.addEventListener('submit', e => {
        let result = true
        const inputs = form.querySelectorAll('input')
        inputs.forEach(input => {
          const errorSelector = input.dataset.errorSelector
          const errorElelement = errorSelector ? document.querySelector(errorSelector) : null
          if (!validateField(input)) {
            result = false
            input.parentNode.classList.add('formfield-invalid')
            if (errorElelement) {
              errorElelement.classList.add('show')
            }
          } else {
            input.parentNode.classList.remove('formfield-invalid')
            if (errorElelement) {
              errorElelement.classList.remove('show')
            }
          }
        })
        if (!result) {
          e.preventDefault()
        }
      })
    })
  }
}

const validateField = (field) => {
  let result = true
  if (field.dataset.required) {
    switch (field.type) {
      case "checkbox":
        result = field.checked !== false
        break;
      case "email":
        result = validateEmail(field.value)
        break;
      default:
        result = field.value !== ''
        break;
    }
  }
  return result
}
const validateEmail = (email) => {
  const re = /\S+@\S+\.\S+/
  return re.test(email)
}